/**
 * Evidence IDs passed to get_aggregations — logic differs slightly by surface (historical).
 */

/** Right-bar scroller / cards: container → child IDs only; else → this evidence. */
export function aggregationIdsForDrawer(evidence: {
  _id?: string;
  isContainer?: boolean;
  hasChildren?: boolean;
  childEvidences?: { _id?: string }[];
}): string[] {
  if (!evidence?._id) return [];
  if (evidence.isContainer && evidence.hasChildren) {
    return (evidence.childEvidences ?? []).map((c) => String(c._id));
  }
  return [String(evidence._id)];
}

/**
 * Idea list cards (EvidenceCardAi / EvidenceCardNiv): only multi-customer containers
 * request aggregated impact; single evidences use nested fields on the item.
 */
export function aggregationIdsForListCard(item: {
  _id?: string;
  isContainer?: boolean;
  hasChildren?: boolean;
  childEvidences?: { _id?: string }[];
}): string[] {
  if (!item?._id) return [];
  if (item.isContainer && item.hasChildren) {
    return (item.childEvidences ?? []).map((c) => String(c._id));
  }
  return [];
}

/** Card attributes row: container → children + parent ID; else → [] (impact read from nested fields). */
export function aggregationIdsForCardAttributes(item: {
  _id?: string;
  isContainer?: boolean;
  hasChildren?: boolean;
  childEvidences?: { _id?: string }[];
}): string[] {
  if (!item?._id) return [];
  if (item.isContainer && item.hasChildren) {
    return [
      ...(item.childEvidences ?? []).map((c) => String(c._id)),
      String(item._id),
    ];
  }
  return [];
}
